<div class="row col-12 p-0 m-0 main-page-section ">

  <div class="col-12 p-0 container-fluid reports-section">



    <div class="col-height">


      <div class="breadcrumbs-section padding-report">
        <span class="prev-page  prev"><a routerLink="/overview">Home</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">Reports</span>
      </div>


      <!--report type header -->
      <div class="d-flex justify-content-between padding-report-heading pb-3 pl-5 ml-2">
        <div class="meeting-room-report pointer-link col-9" (clickOutside)="onClickedOutside($event)"
          [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #pr="ngbPopover" (click)="openPopover(pr)"
          placement="bottom" popoverClass='dash-popover1 dashboard-popover1'>
          <span *ngIf="selectedIndex==3">Employee Report</span>
          <span *ngIf="selectedIndex==2">Events Report</span>
          <span *ngIf="selectedIndex==1">VMS Report</span>
          <span *ngIf="selectedIndex==0">Fire Warden Report - Company</span>
          <span *ngIf="selectedIndex==5">Payment of charge report</span>
          <span *ngIf="selectedIndex==4">Payment of Receipt report</span>
          <!-- <span *ngIf="selectedIndex==60">RFID Report</span> -->
          <span *ngIf="selectedIndex==6">Survey Report</span>
          <span *ngIf="selectedIndex==7">Facility Report</span>
          <span *ngIf="selectedIndex==8">Meeting Room Report</span>

          <img src="../../../assets/images/down-arrow.png" class="padding-left-image pr-1" loading="lazy" />
        </div>
        <div>
          <ng-template #popContent>
            <div class="dashboard-popover1 ">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let report of ((prod==true)?prodReportsList:reportsList);let i=index"
                    (click)="selectedReportType(report.index);openPopover(pr)">
                    <div class="popover-content pl-3 email-width"
                      [class]="selectedIndex==report.index?'bold-font':'normal-font'">
                      {{report.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png" *ngIf="selectedIndex==report.index" class="pl-5 "
                        loading="lazy" />
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </ng-template>
        </div>

        <div class="col-3" *ngIf="totalRows>0&&(selectedIndex==1)" [ngbPopover]="popDownloadContentOnlyVms"
          triggers="manual" #pv="ngbPopover" (click)="openPopover(pv)" popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp;&#9660;</span></button>
        </div>

        <div class="col-3" *ngIf="totalRows>0&&(selectedIndex==8)" [ngbPopover]="popDownloadContentOnlyMeetingRoom"
          triggers="manual" #pv1="ngbPopover" (click)="openPopover(pv1)" popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp;&#9660;</span></button>
        </div>

        <div class="col-3"
          *ngIf="totalRows>0&&(selectedIndex==2||selectedIndex==3||selectedIndex==60||selectedIndex==6||selectedIndex==7)"
          [ngbPopover]="popDownloadContent" triggers="manual" #pd="ngbPopover" (click)="openPopover(pd)"
          popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp; &#9660;</span></button>
        </div>

        <div class="col-3" *ngIf="totalRows>0&&(selectedIndex==4||selectedIndex==5)"
          [ngbPopover]="popPaymentDownloadContent" triggers="manual" #pd="ngbPopover" (click)="openPopover(pd)"
          popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp; &#9660;</span></button>
        </div>


        <div>
          <ng-template #popPaymentDownloadContent>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let downloadTypes of paymentDownloadType"
                    (click)="selectedReportDownload(downloadTypes);openPopover(pd)">
                    <div class="popover-content pl-3 email-width">
                      {{downloadTypes.type}}
                    </div>
                    <div>
                      <!-- <img src="/assets/images/tick.png"
                      *ngIf="SelectedDownloadReportType.includes(downloadTypes.id) || (downloadTypes.id == null && SelectedDownloadReportType.length == 0)"
                      class="pl-5 " loading="lazy" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>


        <div>
          <ng-template #popDownloadContent>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let downloadTypes of DownloadTypes"
                    (click)="selectedReportDownload(downloadTypes);openPopover(pd)">
                    <div class="popover-content pl-3 email-width">
                      {{downloadTypes.type}}
                    </div>
                    <div>
                      <!-- <img src="/assets/images/tick.png"
                        *ngIf="SelectedDownloadReportType.includes(downloadTypes.id) || (downloadTypes.id == null && SelectedDownloadReportType.length == 0)"
                        class="pl-5 " loading="lazy" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div>
          <ng-template #popDownloadContentOnlyVms>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    (click)="downloadExclVms();openPopover(pv)">
                    <div class="popover-content pl-3 email-width">
                      Download as Excel
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div>
          <ng-template #popDownloadContentOnlyMeetingRoom>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    (click)="downloadExclMeetingRoom();openPopover(pv1)">
                    <div class="popover-content pl-3 email-width">
                      Download as Excel
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Filter section -->
      <div class="col-12 d-flex justify-content-start  row borders m-0 p-0 ">
        <div class="col-3  borders-right d-flex justify-content-between relative-content ml-5">

          <!-- activity type filter -->
          <div class="pt-3 pb-3" *ngIf="selectedIndex==0" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Activity Type</div>

            <div class="meeting-sub-label">{{selectedActivityType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>

            <div>
              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let activity of activityType;let i=index"
                        (click)="selectActivityType(activity);openPopover(p0)">
                        <div class="popover-content pl-3 email-width">
                          {{activity.name}}
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- invite type filter -->
          <div class="pt-3 pb-3" *ngIf="selectedIndex==1" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Invite Type</div>

            <div class="meeting-sub-label">{{multiSelectionInvitationType.length>1?formatString(selectedType)+" +"+
              selctionlength :formatString(selectedType)}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>



              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let invite of invitationTypes;let i=index"
                        (click)="selectInviteType(invite);openPopover(p0)">
                        <div class="popover-content pl-3 email-width" style="width: 170px;"
                          [class]="multiSelectionInvitationType.includes(invite?.invitationTypeId) ?'bold-font1':'normal-font1'">
                          {{formatString(invite.invitationType)}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionInvitationType.includes(invite.invitationTypeId) || (invite.invitationTypeId == null && multiSelectionInvitationType.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <!-- event category filter -->
          <div class="pt-3 pb-3" *ngIf="selectedIndex==2" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popEventCat" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Event Category</div>
            <div class="meeting-sub-label" *ngIf="multiSelectioneventType.length!==0">
              {{multiSelectioneventType.length>1?selectedEventType+" +"+
              selctionEventlength :selectedEventType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div class="meeting-sub-label" *ngIf="multiSelectioneventType.length==0">All <img
                src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" /></div>


            <div>
              <ng-template #popEventCat>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let cat of eventTypes  ;let i=index" (click)="selectEventType(cat);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                          [class]="(cat.eventCategoryId !== null && multiSelectioneventType.includes(cat.eventCategoryId)) || (cat.eventCategoryId == null && (multiSelectioneventType.length == 0))?'bold-font1':'normal-font1'">
                          {{cat.eventCategoryName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="(cat.eventCategoryId !== null && multiSelectioneventType.includes(cat.eventCategoryId)) || (cat.eventCategoryId == null && (multiSelectioneventType.length == 0))"
                            class="pl-5 " loading="lazy" />
                        </div>


                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==3" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popEventCat" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">VMS Status</div>

            <div class="meeting-sub-label">{{selectedVmsStatus}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>

            <div>
              <ng-template #popEventCat>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let status of vmsStatus  ;let i=index"
                        (click)="selectVmsStatus(status);openPopover(p0)">
                        <div class="popover-content pl-3 email-width">
                          {{status.name}}
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <!-- payment report -->
          <div class="pt-3 pb-3" *ngIf="selectedIndex==4||selectedIndex==5" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p4="ngbPopover"
            (click)="openPopover(p4)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Payment Module</div>

            <div class="meeting-sub-label">{{paymentType}}<img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>

              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let item of paymentTypes;let i=index"
                        (click)="selectPaymentType(item.id);openPopover(p4)">
                        <div class="popover-content pl-3 email-width" style="width: 193px;"
                          [class]="paymentType==item.paymentType ?'bold-font1':'normal-font1'">
                          {{item.paymentType}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png" *ngIf="paymentType==item.paymentType" class="pl-5 "
                            loading="lazy" />
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==60" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popOrganization" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Organization
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font">{{multiSelectionOrganizations.length>1?selectedOrganzation+" +"+ selctionlength
              :selectedOrganzation}}</div>
            <div>
              <ng-template #popOrganization>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let tenant of tenants ;let i=index" (click)="selectOrgatizationRfid(tenant)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(tenant?.id) ?'bold-font':'normal-font'">
                          {{tenant.companyName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(tenant.id) || (tenant.id == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==6" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popSurvey" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Survey Type
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <div class="font">{{selctionlength >= 1 ? selectedSurveyName+" +"+ selctionlength : selectedSurveyName}}
            </div>
            <div>
              <ng-template #popSurvey>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let svtype of mainSurveyTypes ;let i=index" (click)="selectOrgatizationSurvey(svtype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(svtype?.surveyTypeId) ?'bold-font':'normal-font'">
                          {{svtype.surveyTypeName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(svtype.surveyTypeId) || (svtype.surveyTypeId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==7" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popFacility" triggers="manual" #p2="ngbPopover"
            (click)="openPopover(p2)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Facility Type
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <!-- <div class="font">{{selctionlength >= 1 ? selectedFacilityName+" +"+ selctionlength : selectedFacilityName}}</div> -->
            <div class="font">{{selectedFacilityName}}</div>
            <div>
              <ng-template #popFacility>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let fatype of mainFacilityTypes ;let i=index"
                        (click)="selectOrgatizationFacility(fatype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(fatype?.facilityTypeId) ?'bold-font':'normal-font'">
                          {{fatype.facilityTypeName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(fatype.facilityTypeId) || (fatype.facilityTypeId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==8" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popMeetingRoom" triggers="manual" #p22="ngbPopover"
            (click)="openPopover(p22)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class=" meeting-label center-align box-size pointer-link text-left usage-for"> Meeting Type
            <img src="/assets/images/Path.png" class=" pr-3 access-point-arrow" loading="lazy" />
            <!-- <div class="font">{{selctionlength >= 1 ? selectedFacilityName+" +"+ selctionlength : selectedFacilityName}}</div> -->
            <div class="font">{{selectedMeetingRoomName}}</div>
            <div>
              <ng-template #popMeetingRoom>
                <div class="dashboard-popover">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let matype of mainMeetingRoomTypes ;let i=index"
                        (click)="selectOrgatizationMeetingRoom(matype)">
                        <div class="popover-content pl-3 email-width"
                          [class]="multiSelectionOrganizations.includes(matype?.meetingTypeId) ?'bold-font':'normal-font'">
                          {{matype.meetingTypeName}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionOrganizations.includes(matype.meetingTypeId) || (matype.meetingTypeId == null && multiSelectionOrganizations.length == 0)"
                            class="pl-4" loading="lazy" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- from date filter -->
        <div class=" pt-3 pb-3 borders-right col-2 " [ngClass]="{'disbale-date': selectedIndex==3}">
          <div class="pl-3">
            <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">From</span>
            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate" ngbDatepicker
              #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">
            <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>
          </div>
        </div>

        <!-- to date filter -->
        <div class="pl-3 pt-3 pb-3 col-2 borders-right  " [ngClass]="{'disbale-date': selectedIndex==3}">
          <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">To</span>
          <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
            #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
          <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>
        </div>

        <!-- search term filter -->
        <div [ngClass]="'col-4'"
          *ngIf="selectedIndex==1||selectedIndex==2||selectedIndex==3||selectedIndex==60||selectedIndex==6||selectedIndex==7||selectedIndex==8">
          <label for="search">
            <img loading="lazy" [ngClass]="selectedIndex==0?'image-pos-credit':'image-pos'" class=" search-layout"
              src="/assets/images/search.png" alt="search" style="left:auto !important">
            <input class="search-box search-padding placeholder-text " type="text" name="search" id="menu-search"
              [(ngModel)]="searchText" placeholder="Type here to search…">
          </label>
        </div>

        <!-- payment status filter -->
        <div class="col-3 d-flex justify-content-between relative-content">

          <!-- payment report -->
          <div class="pt-3 pb-3" *ngIf="selectedIndex==4||selectedIndex==5" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p4="ngbPopover"
            (click)="openPopover(p4)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Payment Status</div>

            <div class="meeting-sub-label">{{paymentStatusType}}<img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>
            <div>

              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let itempay of paymentStatysTypes;let i=index"
                        (click)="selectPaymentStatus(itempay.id);openPopover(p4)">
                        <div class="popover-content pl-3 email-width" style="width: 193px;"
                          [class]="paymentStatusType==itempay.paymentStatusType ?'bold-font1':'normal-font1'">
                          {{itempay.paymentStatusType}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png" *ngIf="paymentStatusType==itempay.paymentStatusType"
                            class="pl-5 " loading="lazy" />
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>

        </div>

        <!-- <div class="pt-3 pb-3" *ngIf="selectedIndex==4||selectedIndex==5" (clickOutside)="onClickedOutside($event)"
        [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p4="ngbPopover"
        (click)="openPopover(p4)" placement="bottom" popoverClass='dash-popover dashboard-popover'
        class="meeting-label center-align pointer-link text-center usage-for">
        <div class="text">Payment Status</div>

        <div class="meeting-sub-label">All<img src="/assets/images/Path.png" class=" pr-3 access-point-arrow"
            loading="lazy" /></div>
        <div>

          <ng-template #popInviteType>
            <div class="dashboard-popover ">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let itempay of paymentStatysTypes;let i=index"
                    (click)="selectPaymentStatus(itempay.id);openPopover(p4)">
                    <div class="popover-content pl-3 email-width" style="width: 193px;"
                      [class]="paymentStatusType==itempay.paymentStatusType ?'bold-font1':'normal-font1'">
                      {{itempay.paymentStatusType}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png" *ngIf="paymentStatusType==itempay.paymentStatusType"
                        class="pl-5 " loading="lazy" />
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div> -->


      </div>

      <label class="padding-report pt-2 pb-2 column-data mt-5"
        *ngIf="totalRows>0&&(selectedIndex==2||selectedIndex==3||selectedIndex==4||selectedIndex==5||selectedIndex==60||selectedIndex==6||selectedIndex==7)">
        {{totalRows}} results found for you
        <p *ngIf="selectedIndex==2" class="mb-0"><small>Complete participation list is available in the respective
            events section.</small></p>
      </label>
      <label class="padding-report pt-2 pb-2 column-data" *ngIf="totalCountList>0&&(selectedIndex==1)"
        style="margin-top: 10px;">
        <span *ngIf="(vmsList|filter:searchText)?.length == 10">{{totalCountList}} results found for you</span>
        <span *ngIf="(vmsList|filter:searchText)?.length != 10">{{(vmsList|filter:searchText)?.length}} results found
          for you</span>
      </label>
      <label class="padding-report pt-2 pb-2 column-data" *ngIf="totalCountList>0&&(selectedIndex==8)"
        style="margin-top: 10px;">
        <span *ngIf="(listMeetingRoom|filter:searchText)?.length == 10">{{totalCountList}} results found for you</span>
        <span *ngIf="(listMeetingRoom|filter:searchText)?.length != 10">{{(listMeetingRoom|filter:searchText)?.length}}
          results found
          for you</span>
      </label>
      <empty-state *ngIf=" (  selectedIndex==1 && vmsList?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==2 && eventList?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==0 && fireWardenList?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==3 && employeesList?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==4 && paymentReceiptData?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==5 && paymentReceiptData?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==60 && listfrids?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==6 && listSurvey?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==7 && listFacility?.length == 0 )">
      </empty-state>
      <empty-state *ngIf=" (  selectedIndex==8 && listMeetingRoom?.length == 0 )">
      </empty-state>
    </div>

    <!-- search results -->
    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==0 && fireWardenList?.length > 0"
      [ngClass]="{'horizontal-scrollable': fireWardenList.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="fireWardenList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',fireWardenList)"></th>
            <th scope="col">ERT Member's Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedTime',fireWardenList)"></th>
            <th scope="col">Activity Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',fireWardenList)"></th>
            <th scope="col">ERT Member name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',fireWardenList)"></th>
            <th scope="col">Scanned Employee Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedEmployeeName',fireWardenList)"></th>
            <th scope="col">Scanned Employee Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeName',fireWardenList)"></th>

            <th scope="col">Scanned Employee Contact Number<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search"
                (click)="sort('ScannedEmployeeContactNumber',fireWardenList)"></th>

            <th scope="col">Scan Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',fireWardenList)"></th>
            <th scope="col">Scan Time <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',fireWardenList)"></th>

            <th scope="col">Visitor Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',fireWardenList)"></th>

            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',fireWardenList)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fireWard of fireWardenList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:fireWardenList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{fireWard.ertCompnayName}}</td>
            <td>{{selectedActivityType}}</td>
            <td>{{fireWard.ertMbrName}}</td>
            <td>{{fireWard.employeeType}}</td>
            <td>{{fireWard.scannedEmployeeName}}</td>
            <td>{{fireWard.mobileNumber}}</td>
            <td>{{fireWard.scannedDate}}</td>
            <td>{{fireWard.scannedTime}}</td>
            <td>{{fireWard.scannedEmployeeEmail }}</td>
            <td>{{fireWard.parKName}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==1 && vmsList?.length > 0"
      [ngClass]="{'horizontal-scrollable': vmsList?.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="vmsList?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',vmsList)"></th>
            <!-- <th scope="col">System Record Id<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('systemRecordId',vmsList)"></th> -->
            
            <!-- <th scope="col">Badge no.<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('badgeNumber',vmsList)"></th> -->

            <th scope="col">Visitor Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorName',vmsList)"></th>
            <th scope="col">Visitor Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorEmail',vmsList)"></th>
            <th scope="col">Visitor Mobile No <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorMobileNumber',vmsList)"></th>
            <th scope="col">Invite Platform<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('inviteType',vmsList)"></th>

            <th scope="col">Visitor Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorCompany',vmsList)"></th>


            <th scope="col">Visitor Vehicle Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorVehicleType',vmsList)"></th>

            <th scope="col">Visitor Vehicle Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorVehicleNumber',vmsList)"></th>

            <th scope="col">Date of Visit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfVisit',vmsList)"></th>
            <th scope="col">Time-in<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeIn',vmsList)"></th>
            <th scope="col">Time-out<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeOut',vmsList)"></th>

            <!-- <th scope="col">Badge Returned Status <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('badgeReturnedStatus',vmsList)"></th> -->

            <th scope="col">Host Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostName',vmsList)"></th>
            <th scope="col">Host Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('HostCompany',vmsList)"></th>
            <th scope="col">Host Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostEmail',vmsList)"></th>

            <th scope="col">Host Mobile no<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostMobileno',vmsList)"></th>


            <th scope="col">Invite Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('invitationType',vmsList)"></th>

            <th scope="col">Purpose<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('purpose',vmsList)"></th>
            <th scope="col">Purpose Category<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('purposeCategory',vmsList)"></th>
            <!-- <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',vmsList)"></th> -->
            <th scope="col">Building Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('building ',vmsList)"></th>
            <th scope="col">Photo Id Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('photoId ',vmsList)"></th>

            <th scope="col">Gate No.<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('gateNo ',vmsList)"></th>
            <th scope="col">Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('status ',vmsList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vms of vmsList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: pageNo,
          totalItems:totalCountList }; let i=index" [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <!-- <td>{{vms.systemRecordId}}</td> -->
            <!-- <td>{{vms?.badgeNumber}}</td> -->
            <td>{{vms.visitorName}}</td>
            <td>{{vms.visitorEmail }}</td>
            <td><span
                *ngIf="vms.visitorMobileNumber">+91</span>{{vms.visitorMobileNumber.length>10?vms.visitorMobileNumber.substring(3):vms.visitorMobileNumber}}
            </td>
            <td>{{vms.inviteType }}</td>
            <td>{{vms.visitorCompany}}</td>
            <td>{{vms.visitorVehicleType }}</td>
            <td>{{vms?.visitorVehicleNumber}}</td>
            <td>{{vms.dateOfVisit}}</td>
            <td>{{vms.timeIn}}</td>
            <td>{{vms.timeOut}}</td>
            <!-- <td>{{vms.badgeReturnedStatus}}</td> -->
            <td>{{vms.hostName}}</td>
            <td>{{vms.hostCompany}}</td>
            <td>{{vms.hostEmail}}</td>
            <td><span
                *ngIf="vms.hostMobileno">+91</span>{{vms.hostMobileno?.length>10?vms.hostMobileno.substring(3):vms.hostMobileno}}
            </td>
            <td>{{formatString(vms.invitationType)}}</td>
            <td>{{vms.purpose}}</td>
            <td>{{vms.purposeCategory}}</td>
            <!-- <td>{{vms.parkName}}</td> -->
            <td>{{vms.building}}</td>
            <td>{{vms?.photoIdType}}</td>
            <td>{{vms.gateNo}}</td>
            <td>{{formatString(vms.invitationType)=='Bulk Invite'?vms?.status:''}}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==2 && eventList.length > 0"
      [ngClass]="{'horizontal-scrollable': eventList.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="eventList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Event Title <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',eventList)"></th>
            <th scope="col">Event Category<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>

            <th scope="col">Park<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Participation Type <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>

            <th scope="col">Event Start Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDate',eventList)"></th>
            <th scope="col">Event End Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDate',eventList)"></th>

            <!-- <th scope="col">Event Participation Type <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Team Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th> -->

            <th scope="col">Participation (Total Count)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Guest (Total Count)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>

            <!-- <th scope="col">Participant Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">Participant Captain Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">Captain’s Contact Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Captain’s Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Participant Name(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Participant Email(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Attendance<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Feedback<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Event initiated By<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th> -->

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of eventList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:eventList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{event?.eventTitle}}</td>
            <td>{{event?.eventCategory}}</td>
            <td>{{event?.parkName}}</td>
            <td>{{event?.eventParticipantType}}</td>
            <td>{{formatDateAll(event?.eventStartDate,'date')}}</td>
            <td>{{formatDateAll(event?.eventEndDate,'date')}}</td>
            <!-- <td>{{event?.eventParticipantType}}</td>
            <td>{{event?.teamName}}</td> -->
            <td style="text-align: center;">{{event?.participantsCount}}</td>
            <td style="text-align: center;">{{event?.guestsCount || 0}}</td>
            <!-- <td>{{event?.participantsCompany}}</td>
            <td>{{event?.captain?.name}}</td>
            <td>{{event?.captain?.phone}}</td>
            <td>{{event?.captain?.email}}</td>
            <td>{{event?.participants}}</td>
            <td>{{event?.participantsEmail}}</td>
            <td>{{event?.attendance}}</td>
            <td>{{event?.feedback}}</td>
            <td>{{event?.eventCreatedBy}}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==3 && employeesList?.length > 0"
      [ngClass]="{'horizontal-scrollable': employeesList.length>0}">
      <table class="table table-borderless table-curved" *ngIf="employeesList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',eventList)"></th>
            <th scope="col">Employee Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>
            <th scope="col">Verification status <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">VMS Status <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>

            <th scope="col">Mobile Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Employee Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of employeesList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:employeesList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{emp.companyName}}</td>
            <td>{{emp.employeeName}}</td>
            <td>{{emp.verificationStatus}}</td>
            <td>{{emp.vmsStatus}}</td>
            <td>{{emp.mobileNumber }}</td>
            <td>{{emp.employeeEmail}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content
      *ngIf="(selectedIndex==4||selectedIndex==5) && paymentReceiptData?.length > 0"
      [ngClass]="{'horizontal-scrollable': paymentReceiptData.length > 0}">
      <table class="table table-borderless table-curved" *ngIf="paymentReceiptData.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Transaction ID<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',eventList)"></th>
            <th scope="col">Username<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>
            <th scope="col">Total Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">IGST %<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">SGST %<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">CGST %<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">Payment Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Timestamp<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
            <th scope="col">Payment Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
            <th scope="col">Booking ID<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
            <!-- <th scope="col">Payment Mode<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                      (click)="sort('employeeName',eventList)"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of paymentReceiptData | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:paymentReceiptData.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{emp.transactionId}}</td>
            <td>{{emp.userName}}</td>
            <td align="right">{{emp.totalAmount | number:'1.2-2'}}</td>
            <td align="center"><span *ngIf="emp.igst!=''">{{emp.igst}}</span><span *ngIf="emp.igst==null">-</span></td>
            <td align="center"><span *ngIf="emp.sgst!=''">{{emp.sgst}}</span><span *ngIf="emp.sgst==null">-</span></td>
            <td align="center"><span *ngIf="emp.cgst!=''">{{emp.cgst}}</span><span *ngIf="emp.cgst==null">-</span></td>
            <td>{{emp.paymentDate}}</td>
            <td>{{emp.timeStamp }}</td>
            <td>{{emp.paymentStatus}}</td>
            <td>{{emp.bookingId}}</td>
            <!-- <td>{{emp.timeStamp }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content" *ngIf="selectedIndex==60  && listfrids?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listfrids?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listfrids?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listfrids)"></th>
            <th scope="col">Organization Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('organizationName',listfrids)"></th>
            <th scope="col">Member Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberName',listfrids)"></th>
            <th scope="col">Member Mobile<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('memberMobile',listfrids)"></th>
            <th scope="col">Member Card Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('memberCardNo',listfrids)"></th>
            <th scope="col">Assinged On<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('assignedOn',listfrids)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let listfrid of listfrids | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:listfrids?.length } ;let i=index;" [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{listfrid.srNo}}</td>
            <td>{{listfrid.organizationName}}</td>
            <td><span *ngIf="listfrid.memberName!='null'">{{listfrid.memberName}}</span><span
                *ngIf="listfrid.memberName==null">-</span></td>
            <td><span *ngIf="listfrid.memberMobile!='null'">{{listfrid.memberMobile}}</span><span
                *ngIf="listfrid.memberMobile==null">-</span></td>
            <td>{{(listfrid.memberCardNo)}}</td>
            <td>{{listfrid.assignedOn}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content" *ngIf="selectedIndex==6  && listSurvey?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listSurvey?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listSurvey?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listSurvey)"></th>
            <th scope="col">Survey Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('surveyName',listSurvey)"></th>
            <th scope="col">Survey Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('surveyType',listSurvey)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDate',listSurvey)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDate',listSurvey)"></th>
            <!-- <th scope="col">Coupon Assinged<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('couponAssigned',listSurvey)"></th> -->
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',listSurvey)"></th>
            <th scope="col" class="building-list">Building Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('buildingNames',listSurvey)"></th>
            <th scope="col" class="tenant-list">Tenant Name<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('tenantNames',listSurvey)"></th>
            <th scope="col">Download Report</th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let survey of listSurvey | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:(listSurvey|filter:searchText)?.length } ;let i=index;"
            [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i + 1}}</td>
            <td>{{survey.surveyName}}</td>
            <td>{{survey.surveyType}}</td>
            <td>{{formatDateAll(survey?.startDate,'date')}}</td>
            <td>{{formatDateAll(survey?.endDate,'date')}}</td>
            <!-- <td>{{survey.couponAssigned}}</td> -->
            <!-- <td>{{survey.parkName}}</td> -->
            <td class="park-list"><span *ngFor="let park of survey?.parkNames; let last = last">{{park}}{{ !last ? ', '
                : ''
                }}</span></td>
            <td class="building-list"><span
                *ngFor="let building of survey?.buildingNames; let last = last">{{building}}{{ !last ? ', ' : ''
                }}</span></td>
            <td class="tenant-list"><span *ngFor="let tenant of survey?.tenantNames; let last = last">{{tenant}}{{ !last
                ? ', ' : '' }}</span></td>
            <td><a [attr.href]="reportDownloadUrl(survey?.surveyId)" download><i class="fa fa-download"
                  aria-hidden="true"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content" *ngIf="selectedIndex==7  && listFacility?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listFacility?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listFacility?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listFacility)"></th>
            <th scope="col">Faclity Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityName',listFacility)"></th>
            <th scope="col">Facility Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityTypeName',listFacility)"></th>
            <th scope="col">Facility Capacity<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('facilityCapacity',listFacility)"></th>
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',listFacility)"></th>
            <th scope="col">Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('rateHourly',listFacility)"></th>
            <th scope="col">Additional Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalHourRate',listFacility)"></th>
            <th scope="col">Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dailyRate',listFacility)"></th>
            <th scope="col">Additional Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalDayRate',listFacility)"></th>
            <th scope="col">Security Deposit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('securityDeposit',listFacility)"></th>
            <th scope="col">Booking Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('bookingTypeName',listFacility)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDateTime',listFacility)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDateTime',listFacility)"></th>
            <th scope="col">Duration(Hours)<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',listFacility)"></th>
            <th scope="col">Total Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('totalAmount',listFacility)"></th>
            <th scope="col">Created By<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('createdBy',listFacility)"></th>
            <th scope="col">Payment Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('paymentStatus',listFacility)"></th>
            <th scope="col">Refund Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('refundStatus',listFacility)"></th>
            <th scope="col">Transaction Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('transactionDate',listFacility)"></th>
            <th scope="col">Refund Initiation Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('refundInitiationDate',listFacility)"></th>
            <th scope="col">Refund Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('refundAmount',listFacility)"></th>
            <th scope="col">Transaction ID<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('transactionId',listFacility)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let facility of listFacility | filter:searchText | paginate: { itemsPerPage: 10,
            currentPage: page, totalItems:(listFacility|filter:searchText)?.length } ;let i=index;"
            [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i + 1}}</td>
            <td>{{facility?.facilityName}}</td>
            <td>{{facility?.facilityTypeName}}</td>
            <td>{{facility?.facilityCapacity}}</td>
            <td>{{facility?.parkName}}</td>
            <td>₹{{facility?.rateHourly != "" ? facility?.rateHourly : '0.00'}}</td>
            <td>₹{{facility?.additionalHourRate != "" ? facility?.additionalHourRate : '0.00'}}</td>
            <td>₹{{facility?.dailyRate != "" ? facility?.dailyRate : '0.00'}}</td>
            <td>₹{{facility?.additionalDayRate != "" ? facility?.additionalDayRate : '0.00'}}</td>
            <td>₹{{facility?.securityDeposit != "" ? facility?.securityDeposit : '0.00'}}</td>
            <td>{{facility?.bookingTypeName}}</td>
            <td>{{formatDateAll(facility?.startDateTime,'date')}} {{formatTimeAll(facility?.startDateTime,'time')}}</td>
            <td>{{formatDateAll(facility?.endDateTime,'date')}} {{formatTimeAll(facility?.endDateTime,'time')}}</td>
            <td>{{facility?.duration}}</td>
            <td>₹{{facility?.totalAmount}}</td>
            <td>{{facility?.createdBy}}</td>
            <td>{{facility?.paymentStatus}}</td>
            <td>{{facility?.refundStatus}}</td>
            <td>{{formatDateAll(facility?.transactionDate,'date')}}</td>
            <td>{{formatDateAll(facility?.refundInitiationDate,'date')}}</td>
            <td>₹{{facility?.refundAmount!=null ? facility?.refundAmount : '0.00'}}</td>
            <td>{{facility?.transactionId}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="scroll-content" *ngIf="selectedIndex==8 && listMeetingRoom?.length > 0"
      [ngClass]="{'horizontal-scrollable-check-in': listMeetingRoom?.length>0}">
      <table class="table table-borderless table-curved" *ngIf="listMeetingRoom?.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2">Sr.No<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('srNo',listMeetingRoom)"></th>
            <th scope="col">Meeting Room Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkMeetingRoomName',listMeetingRoom)"></th>
            <th scope="col">Capacity<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkMeetingRoomCapacity',listMeetingRoom)"></th>
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',listMeetingRoom)"></th>
            <th scope="col">Company Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('companyName',listMeetingRoom)"></th>
            <th scope="col">Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('rateHourly',listMeetingRoom)"></th>
            <th scope="col">Additional Hourly Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalHourRate',listMeetingRoom)"></th>
            <th scope="col">Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dailyRate',listMeetingRoom)"></th>
            <th scope="col">Additional Daily Rate<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('additionalDayRate',listMeetingRoom)"></th>
            <th scope="col">Security Deposit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('securityDeposit',listMeetingRoom)"></th>
            <th scope="col">Booking Type<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('bookingTypeName',listMeetingRoom)"></th>
            <th scope="col">Start Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('startDateTime',listMeetingRoom)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('endDateTime',listMeetingRoom)"></th>
            <th scope="col">Duration(Hours/Days)<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('duration',listMeetingRoom)"></th>
            <th scope="col">Total Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('totalAmount',listMeetingRoom)"></th>
            <th scope="col">Created By<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('createdBy',listMeetingRoom)"></th>
            <th scope="col">Payment Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('paymentStatus',listMeetingRoom)"></th>
            <th scope="col">Refund Status<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('refundStatus',listMeetingRoom)"></th>
            <th scope="col">Transaction Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('transactionDate',listMeetingRoom)"></th>
            <th scope="col">Refund Initiation Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('refundInitiationDate',listMeetingRoom)"></th>
            <th scope="col">Refund Amount<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('refundAmount',listMeetingRoom)"></th>
            <th scope="col">Transaction ID<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('transactionId',listMeetingRoom)"></th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align: center;" *ngFor="let meeting of listMeetingRoom | filter:searchText  | paginate: { itemsPerPage: 10,
            currentPage: pageNo, totalItems:totalCountList }; let i=index;" [ngClass]="i%2==0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{((indexPage-1)*10)+(i+1)}}</td>
            <td>{{meeting?.parkMeetingRoomName}}</td>
            <td>{{meeting?.parkMeetingRoomCapacity}}</td>
            <td>{{meeting?.parkName}}</td>
            <td>{{meeting?.companyName}}</td>
            <td>₹{{meeting?.rateHourly!=null ? meeting?.rateHourly : '0.00'}}</td>
            <td>₹{{meeting?.additionalHourRate!=null ? meeting?.additionalHourRate : '0.00'}}</td>
            <td>₹{{meeting?.dailyRate!=null ? meeting?.dailyRate : '0.00'}}</td>
            <td>₹{{meeting?.additionalDayRate!=null ? meeting?.additionalDayRate : '0.00'}}</td>
            <td>₹{{meeting?.securityDeposit!=null ? meeting?.securityDeposit : '0.00'}}</td>
            <td>{{meeting?.bookingTypeName}}</td>
            <!-- <td>{{formatDateAll(meeting?.startDateTime,'date')}} {{formatTimeAll(meeting?.startDateTime,'time')}}</td> -->
            <td>{{meeting?.startDateTime}}</td>
            <!-- <td>{{formatDateAll(meeting?.endDateTime,'date')}} {{formatTimeAll(meeting?.endDateTime,'time')}}</td> -->
            <td>{{meeting?.endDateTime}}</td>
            <!-- <td>{{meeting?.duration}}</td> -->
            <td>{{meeting?.dayHoursCountInString}}</td>
            <td>₹{{meeting?.totalAmount}}</td>
            <td>{{meeting?.createdBy}}</td>
            <td>{{meeting?.paymentStatus!=null ? meeting?.paymentStatus : 'NA'}}</td>
            <td>{{meeting?.refundStatus!=null ? meeting?.refundStatus : 'NA'}}</td>
            <td>{{formatDateAll(meeting?.transactionDate,'date')}}</td>
            <td>{{formatDateAll(meeting?.refundInitiationDate,'date')}}</td>
            <td>₹{{meeting?.refundAmount!=null ? meeting?.refundAmount : '0.00'}}</td>
            <td>{{meeting?.transactionId}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="row" *ngIf="(selectedIndex==4||selectedIndex==5) && totalRows > 0" class="display-msg">
      <div class="col-12">
        {{totalRows}} results found for you. Please click on the Download Report button for details
      </div>
    </div>


    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded &&(selectedIndex==3||selectedIndex==0)&&( fireWardenList?.length > 10 ||  employeesList?.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeeting($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>

        <div class="pr-3 ratio-class pt-1" *ngIf="selectedIndex==0">
          {{indexPage}}/{{paginationCount(fireWardenList?.length)}}</div>

        <div class="pr-3 ratio-class pt-1" *ngIf="selectedIndex==3">
          {{indexPage}}/{{paginationCount(employeesList?.length)}}</div>

      </div>


    </div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section" *ngIf="totalCountList>10&&selectedIndex==1">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeVMS($event)" nextLabel=""
      class="d-flex justify-content-center">
    </pagination-controls>

    <!-- <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount(vmsList?.length)}}
    </div> -->
    <div class="pr-3 ratio-class pt-1">
      {{pageNo}}/{{fetchPage(totalCountList)}}</div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section" *ngIf="eventList?.length >10&&selectedIndex==2">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handleEventPageChange($event)" nextLabel=""
      class="d-flex justify-content-center">
    </pagination-controls>

    <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount(eventList?.length)}}</div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section"
  *ngIf="paymentReceiptData?.length >10 && (selectedIndex==4 || selectedIndex==5)">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handelPaymentReceiptReport($event)"
      nextLabel="" class="d-flex justify-content-center">
    </pagination-controls>

    <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount(paymentReceiptData?.length)}}</div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section"
  *ngIf="reportsLoaded && (selectedIndex==60 && listfrids?.length > 10)">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeRfids($event)" nextLabel=""
      class="d-flex justify-content-center">
    </pagination-controls>
    <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listfrids?.length>=10">10/{{listfrids?.length}}</div> -->
    <div class="pr-3 ratio-class pt-1">
      {{page}}/{{paginationCount(listfrids?.length)}}</div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section"
  *ngIf="reportsLoaded && (selectedIndex==6 && listSurvey?.length > 10) ">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeSurvey($event)" nextLabel=""
      class="d-flex justify-content-center">
    </pagination-controls>
    <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listSurvey?.length>=10">10/{{listSurvey?.length}}</div> -->
    <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount((listSurvey|filter:searchText)?.length)}}</div>
  </div>
</div>

<div class="d-flex justify-content-center pagination-section"
  *ngIf="reportsLoaded && (selectedIndex==7 && listFacility?.length > 10) ">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeFacility($event)"
      nextLabel="" class="d-flex justify-content-center">
    </pagination-controls>
    <!-- <div class="pr-3 ratio-class pt-1" *ngIf="listFacility?.length>=10">10/{{listFacility?.length}}</div> -->
    <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount((listFacility|filter:searchText)?.length)}}</div>
  </div>
</div>

<!-- <div class="d-flex justify-content-center pagination-section"
  *ngIf="reportsLoaded && (selectedIndex==8 && listMeetingRoom?.length > 10) ">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeetingRoom($event)"
      nextLabel="" class="d-flex justify-content-center">
    </pagination-controls>
    <div class="pr-3 ratio-class pt-1">
      {{indexPage}}/{{paginationCount((listMeetingRoom|filter:searchText)?.length)}}</div>
  </div>
</div> -->


<div class="d-flex justify-content-center pagination-section" *ngIf="totalCountList>10&&selectedIndex==8">
  <div class="row d-flex pagination-border">
    <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeetingRoom($event)"
      nextLabel="" class="d-flex justify-content-center">
    </pagination-controls>
    <div class="pr-3 ratio-class pt-1">
      {{pageNo}}/{{fetchPage(totalCountList)}}</div>
  </div>
</div>